import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from '../AxiosConfig';
import { Container, Form, Button, Card, Alert } from 'react-bootstrap';

const SetPassword = () => {
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState(null);
  const navigate = useNavigate();
  const { token } = useParams(); 

  const handleSubmit = async () => {
    try {
      await axios.post(`/api/auth/setPassword/${token}`, { password });
      navigate('/login');
    } catch (error) {
      setErrorMessage(error.response?.data?.error || 'Failed to set password');
    }
  };

  return (
    <Container className="mt-5">
      <Card className="shadow-lg p-4">
        <Card.Body>
          <h2 className="text-center mb-4">Set Your Password</h2>
          {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}
          <Form>
            <Form.Group controlId="password" className="mb-3">
              <Form.Label>New Password</Form.Label>
              <Form.Control
                type="password"
                placeholder="Enter your new password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </Form.Group>
            <Button variant="primary" onClick={handleSubmit} className="w-100">
              Set Password
            </Button>
          </Form>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default SetPassword;
